import React, { FC, memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { FieldProps } from 'react-admin'
import { Customer_fields } from 'src/types/globalTypes'

const useStyles = makeStyles((theme) => ({
  root: {
    // display: 'flex',
    // flexWrap: 'nowrap',
    // alignItems: 'center',
  },
  avatar: {
    marginRight: theme.spacing(1),
    marginTop: -theme.spacing(0.5),
    marginBottom: -theme.spacing(0.5),
  },
}))

interface Props extends FieldProps<Customer_fields> {
  size?: string
}

const CustomerCodeField: FC<Props> = ({ record }) => {
  const classes = useStyles()
  return record ? <div className={classes.root}>{record.code}</div> : null
}

CustomerCodeField.defaultProps = {
  source: 'code',
  label: 'Code',
}

export default memo<Props>(CustomerCodeField)
